import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UiModule } from "./ui/ui.module";
import { HeaderComponent } from "./header/header.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { SharedModule } from "./shared/shared.module";
import { NgxPermissionsModule } from "ngx-permissions";

import { AuthInterceptorService } from "./auth/auth-interceptor.service";

import { SocketIoModule } from "ngx-socket-io";

import { NotificationsSocket } from "./notifications/notification.service";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgxMaskModule } from "ngx-mask";
import { NgxEchartsModule } from "ngx-echarts";
import { NgxPanZoomModule } from "ngx-panzoom";
import { ErrorComponent } from "./error/error.component";
import { NotFoundComponent } from "./not-found/not-found.component";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    ErrorComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    UiModule,
    HttpClientModule,
    NgxPermissionsModule.forRoot(),
    SocketIoModule,
    AngularSvgIconModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgxEchartsModule.forRoot({
      echarts: () => import("echarts"),
    }),
    NgxPanZoomModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    NotificationsSocket,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
